import { render, staticRenderFns } from "./composer-voz-orb.vue?vue&type=template&id=26f62058&scoped=true&"
import script from "./composer-voz-orb.vue?vue&type=script&lang=js&"
export * from "./composer-voz-orb.vue?vue&type=script&lang=js&"
import style0 from "./composer-voz-orb.vue?vue&type=style&index=0&id=26f62058&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f62058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f62058')) {
      api.createRecord('26f62058', component.options)
    } else {
      api.reload('26f62058', component.options)
    }
    module.hot.accept("./composer-voz-orb.vue?vue&type=template&id=26f62058&scoped=true&", function () {
      api.rerender('26f62058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/composer-voz-orb/composer-voz-orb.vue"
export default component.exports